import { render } from "./AddService.vue?vue&type=template&id=d27c1bb6&scoped=true"
import script from "./AddService.vue?vue&type=script&lang=js"
export * from "./AddService.vue?vue&type=script&lang=js"

import "./AddService.vue?vue&type=style&index=0&id=d27c1bb6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27c1bb6"]])

export default __exports__